import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { CONTACT } from "../../i18n/translations";

export const Footer = () => {
    const { t } = useLang();
    const f = t.footer;

    return (
        <footer
            className="relative overflow-hidden bg-tinta pt-grain text-white"
            data-testid="site-footer"
        >
            <div className="wrap relative py-16">
                <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr_1.2fr]">
                    <div>
                        <img
                            src="/brand/logos/pentomino-horizontal-inverso.svg"
                            alt="Pentomino"
                            width="170"
                            className="mb-5 h-[26px] w-auto"
                        />
                        <p className="max-w-xs text-[0.95rem] text-[#C5CDD8]">
                            {f.tag}
                        </p>
                        <p
                            className="mt-3 text-sm font-semibold text-coral"
                            style={{ fontStretch: "118%" }}
                        >
                            {f.slogan}
                        </p>
                    </div>

                    <div>
                        <h4 className="mb-4 text-xs font-semibold uppercase tracking-wider text-[#8A95AB]">
                            {f.product}
                        </h4>
                        <ul className="space-y-2 text-[0.95rem]">
                            {f.productLinks.map(([label, href]) => (
                                <li key={href}>
                                    <Link
                                        to={href}
                                        className="text-white/90 hover:text-coral"
                                        data-testid={`footer-link-${href.replace("/", "")}`}
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="mb-4 text-xs font-semibold uppercase tracking-wider text-[#8A95AB]">
                            {f.company}
                        </h4>
                        <ul className="space-y-2 text-[0.95rem]">
                            {f.companyLinks.map(([label, href]) => (
                                <li key={href}>
                                    <Link
                                        to={href}
                                        className="text-white/90 hover:text-coral"
                                        data-testid={`footer-link-${href.replace("/", "")}`}
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="mb-4 text-xs font-semibold uppercase tracking-wider text-[#8A95AB]">
                            {f.contact}
                        </h4>
                        <ul className="space-y-3 text-[0.95rem]">
                            <li className="flex items-start gap-3">
                                <Phone size={16} className="mt-1 text-coral" />
                                <a
                                    href={CONTACT.phoneHref}
                                    className="text-white/90 hover:text-coral"
                                    data-testid="footer-phone"
                                >
                                    {CONTACT.phone}
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail size={16} className="mt-1 text-coral" />
                                <a
                                    href={CONTACT.emailHref}
                                    className="text-white/90 hover:text-coral"
                                    data-testid="footer-email"
                                >
                                    {CONTACT.email}
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin size={16} className="mt-1 text-coral" />
                                <span className="text-white/90">
                                    {f.addressLine1}
                                    <br />
                                    {f.addressLine2}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 flex flex-col gap-3 border-t border-[#2B3B5C] pt-6 text-[0.84rem] text-[#8A95AB] md:flex-row md:items-center md:justify-between">
                    <span>{f.legal}</span>
                    <span>
                        <a
                            href="#"
                            className="hover:text-coral"
                            data-testid="footer-privacy"
                        >
                            {f.privacy}
                        </a>
                    </span>
                </div>
            </div>
        </footer>
    );
};
